import type { HistoryFilter } from "@common/types/auditLog";
import type { StoredLastVisit } from "@components/activityTimeline/lastVisit/lastVisit.lib";
import { storedLastVisitSchema } from "@components/activityTimeline/lastVisit/lastVisit.lib";
import type { ActivityChartDensity } from "@components/activityTimeline/activityChartDensity.lib";
import { activityChartDensitySchema } from "@components/activityTimeline/activityChartDensity.lib";
import type { UseActivityTimelinePageParams } from "@components/activityTimeline/useActivityTimelinePage";
import { useActivityTimelinePage } from "@components/activityTimeline/useActivityTimelinePage";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "@hooks/useWorkspaceUserCache";

/** The History page's timeline wiring, with the last visit and chart density kept per workspace and user. */
export function useHistoryPageTimeline(
    params: Omit<
        UseActivityTimelinePageParams<HistoryFilter>,
        "stored" | "save" | "storedDensity"
    >,
) {
    const [stored, setStored] = useWorkspaceUserCache<StoredLastVisit>(
        WORKSPACE_USER_CACHE_KEYS.ACTIVITY_LAST_VISIT_CACHE_KEY,
        storedLastVisitSchema,
    );
    const [storedDensity, saveDensity] =
        useWorkspaceUserCache<ActivityChartDensity>(
            WORKSPACE_USER_CACHE_KEYS.ACTIVITY_CHART_DENSITY_CACHE_KEY,
            activityChartDensitySchema,
        );
    return useActivityTimelinePage({
        ...params,
        stored,
        save: setStored,
        storedDensity: { stored: storedDensity, save: saveDensity },
    });
}
